import { FormEvent, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { getSuiteLoginUrl } from "@/core/config";
import { routes } from "@/router/all_routes";

export function LoginPage() {
  const { login, isAuthenticated, isLoading } = useAuth();
  const [email, setEmail] = useState("admin@itaas.demo");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (isAuthenticated) {
    return <Navigate to={routes.tenantDashboard} replace />;
  }

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await login({ email, password });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Connexion échouée");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="ph-login-page">
      <div className="ph-login-card">
        <h1 className="h5 mb-3">ITaaS Hospitol</h1>
        <p className="text-muted small">
          Connexion locale (dev). Tenant : <code>demo-hospitol</code> — médecin{" "}
          <code>doctor@hospital.demo</code> · pharmacien <code>pharmacy@hospital.demo</code> · mot de
          passe <code>Admin@123456</code>. En production, utilisez{" "}
          <a href={getSuiteLoginUrl()}>ITaaS Suite</a>.
        </p>
        {error && <div className="alert alert-danger py-2">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">E-mail</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Mot de passe</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={submitting || isLoading}>
            {submitting ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
